import {mxCell, mxConstants, mxGeometry} from "mxgraph-js";

abstract class HCLTreeEdge extends mxCell {
  protected constructor(style: any) {
    super(null, new mxGeometry(), HCLTreeEdge.mapStyles(style));
    this.setEdge(true);
    this.setVertex(false);
  }

  static mapStyles = (s: {[index: string]: any}) => {
    const styles = s;
    styles[mxConstants.STYLE_FONTFAMILY] = 'inherit';
    return Object.entries(styles).map(k => (`${k[0]}=${k[1]}`)).join(';');
  };

  static get inactiveStyle() {
    const style: any = {};
    style[mxConstants.STYLE_FILLCOLOR] = '#bbb0a7';
    style[mxConstants.STYLE_STROKECOLOR] = '#5f5858';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    style[mxConstants.STYLE_FILL_OPACITY] = '60';
    style[mxConstants.STYLE_STROKE_OPACITY] = '60';
    style[mxConstants.STYLE_STROKEWIDTH] = '1';
    return style;
  }

  static get activeStyle() {
    const style: any = {};
    style[mxConstants.STYLE_FILLCOLOR] = '#bbb0a7';
    style[mxConstants.STYLE_STROKECOLOR] = '#c9682c';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    style[mxConstants.STYLE_FILL_OPACITY] = '100';
    style[mxConstants.STYLE_STROKE_OPACITY] = '100';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    return style;
  }
}

export default HCLTreeEdge;
